// import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

// const icon = (name) => (
//   <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
// );

const navConfig = [
  {
    title: 'Announcements',
    path: '/admin/announcements',
  },
  // {
  //   title: 'Slider',
  //   path: '/slider',
  //   // icon: icon('ic_user'),
  // },
  {
    title: 'Board Members',
    path: '/admin/board',
  },
  {
    title: 'Photo Gallery',
    path: '/admin/photoGallery',
  },
  {
    title: 'Tributes',
    path: '/admin/tributes',
  },
  {
    title: 'Members',
    path: '/admin/becomeMember',
  },
  {
    title: 'Users',
    path: '/admin/users',
  },
  {
    title: 'By-Laws',
    path: '/admin/ByLaws',
  },
  {
    title: 'Proxy Form',
    path: '/admin/Proxy_foam',
  },








];

export default navConfig;
